export interface Video {
  id: string;
  name: string;
  eventDate: Date | string;
  thumbnailUrl: string;
  url: string;
  premium: boolean;
  artistName: string;
  videoType: VideoType;
  videoProductType: VideoProductType;
  duration: string;
  description: string;
  videoHost: string;
}

export enum VideoType {
  Live = 'Live',
  VOD = 'VOD',
}

export enum VideoProductType {
  LIVESTREAM = 'LIVESTREAM',
  RENTAL = 'RENTAL',
  PRE_RECORDED_STREAM = 'PRE_RECORDED_STREAM',
  VIDEO_ON_DEMAND = 'VIDEO_ON_DEMAND',
}
